<template>
  <div class="flex flex-wrap items-center mb-base">
          <vs-avatar :src="avatar" size="70px" class="mr-4 mb-4" />
          <div>
            <vs-button @click="toggleShow" class="mr-4 sm:mb-0 mb-2">Upload photo</vs-button>
            <p class="text-sm mt-2">Allowed JPG or PNG.</p>
          </div>
    <my-upload field="img"
               @crop-success="cropSuccess"
               @crop-upload-success="cropUploadSuccess"
               @crop-upload-fail="cropUploadFail"
               v-model="show"
               :width="300"
               :height="300"
               lang-type="en"
               :params="params"
               :headers="headers"
               img-format="png"></my-upload>
<!--    <img :src="avatar">-->
  </div>
</template>

<script>
import myUpload from 'vue-image-crop-upload/upload-2.vue';
import Cookies from "js-cookie";
import {RepositoryFactory} from '@/repository/RepositoryFactory'
import SuccessMessage from "@/mixins/SuccessMessage";
import ErrorMessages from "@/mixins/ErrorMessages";
import {mapActions} from "vuex";
const StaffRepository = RepositoryFactory.get('staff');

export default {
  name: "ProfileImageSection",
  props: {
    avatar: {
      default: "",
      type: String
    },
    auth_id: {
      type: Number
    }
  },
  mixins: [ErrorMessages, SuccessMessage],
  data() {
    return {
      show: false,
      params: {
        token: Cookies.get('current_user_token'),
        name: 'avatar'
      },
      headers: {
        authorization: 'Bearer ' + Cookies.get('current_user_token'),
      },
    }
  },
  components: {
    'my-upload': myUpload
  },
  methods: {
    ...mapActions(['updateProfileAvatar']),
    toggleShow() {
      this.show = !this.show;
    },

    /**
     * crop success
     *
     * [param] imgDataUrl
     * [param] field
     */
    async cropSuccess(imgDataUrl, field){
      try {
        await StaffRepository.uploadProfileImage(this.auth_id, {avatar: imgDataUrl})
        await this.updateProfileAvatar(imgDataUrl)
        this.showSuccessMessage('Profile image updated successfully')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.avatar = imgDataUrl;
    },

    /**
     * upload success
     *
     * [param] jsonData  server api return data, already json encode
     * [param] field
     */
    cropUploadSuccess(jsonData, field){
    },

    /**
     * upload fail
     *
     * [param] status    server api return error status, like 500
     * [param] field
     */
    cropUploadFail(status, field){
    }
  },
}
</script>

<style scoped>

</style>
